import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { Api, AuthedHeaders } from '@dashboard/lib/api'

import { APIResponse, ProfileContent } from '@dashboard/lib/types'

export interface GroupsDiscDataOptions {
  data_tags: string[][]
  limit?: number
}

interface GroupDiscDataRequestParams {
  data_tags: Record<string, string[]>
  limit?: number
}

export function groupsDiscDataKey(
  groupId: string,
  { data_tags, limit }: GroupsDiscDataOptions,
) {
  return `${groupId}-${data_tags
    .map(tags => tags.join('-'))
    .join('-')}-${limit}`
}

export const REQUEST = 'GROUPS_DISC_DATA_START'
interface RequestAction {
  type: typeof REQUEST
  key: string
}
const request = (key: string): RequestAction => ({
  type: REQUEST,
  key,
})

export const REQUEST_SUCCESS = 'GROUPS_DISC_DATA_SUCCESS'
interface RequestSuccessAction {
  type: typeof REQUEST_SUCCESS
  key: string
  data: ProfileContent
}
const requestSuccess = (
  key: string,
  data: ProfileContent,
): RequestSuccessAction => ({
  type: REQUEST_SUCCESS,
  key,
  data,
})

export const REQUEST_FAILURE = 'GROUPS_DISC_DATA_FAILURE'
interface RequestFailureAction {
  type: typeof REQUEST_FAILURE
  key: string
  error: unknown
}
const requestFailure = (key: string, error: unknown): RequestFailureAction => ({
  type: REQUEST_FAILURE,
  key,
  error,
})

export type Action = RequestAction | RequestSuccessAction | RequestFailureAction

export function getGroupsDiscData(
  groupId: string,
  options: {
    data_tags: string[][]
    limit?: number
  },
  headers?: AuthedHeaders,
) {
  return async (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
    return new Promise<ProfileContent>((resolve, reject) => {
      const key = groupsDiscDataKey(groupId, options)
      dispatch(request(key))

      const data_tags: Record<string, string[]> = {}
      options.data_tags.forEach((tag, index) => {
        data_tags[index] = tag
      })

      const params: GroupDiscDataRequestParams = { data_tags }

      if (options.limit) params.limit = options.limit

      Api(headers)
        .post<APIResponse<ProfileContent>>(`/groups/${groupId}/data`, params)
        .then(({ data }) => {
          dispatch(requestSuccess(key, data.data))

          resolve(data.data)
        })
        .catch(err => {
          dispatch(requestFailure(key, err))
          reject(
            `Error calling getGroupsDiscData (Status: ${err.response
              ?.status}): ${JSON.stringify(err.response?.data)}`,
          )
        })
    })
  }
}
